/**
 *  Wraps single validation function into universal composable approach
 *  @param f - validation function of type T
 *  @param errorMessage - if validation faliled there will be message about failure
 *  @returns validatior function
 */
function wrapSingleFn(f) {
    return (argument) => {
        const { isValid, message } = f(argument);
        if (message) {
            return { isValid, messages: [message] };
        }
        return { isValid };
    };
}
function validate(toBeValidated) {
    return (acc, current) => {
        const { isValid, message } = current(toBeValidated);
        if (isValid) {
            return acc;
        }
        // collection of final result messages
        const { messages = [] } = acc;
        return { isValid, messages: [...messages, message] };
    };
}
/**
 *   Provides generation of dynamic validation
 *   @param validators - could be one validation function or collection of it.
 *   @returns validatior function
 */
export function createValidator(validators) {
    return Array.isArray(validators)
        ? (beValidated) => validators.reduce(validate(beValidated), { isValid: true })
        : wrapSingleFn(validators);
}
